var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingState.loading > 0)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner"},[_vm._v("$t('loading')")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }